<template>
  <nav
    class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent"
    id="navbar-right-navigation">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-toggle">
          <button type="button" class="navbar-toggler">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" href="#pablo"></a>
      </div>
      <button class="navbar-toggler" type="button" id="button-show-navbar-right-navigation">
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="navigation">
        <div class="navbar-nav mr-2">
          <button class="btn btn-outline-primary" @click="downloadPluginZipFile(item)">
            <i class="fa fa-download"></i> {{ $t('common.download_kintone_plugin') }}
          </button>
        </div>
        <ul class="navbar-nav" id="content-navbar-right">
          <li class="nav-item d-flex">
            <div class="align-self-center">
              <form class>
                <select class="form-control col" name="language" id="control-set-lang" v-model="$i18n.locale" @change="setLang">
                  <option value="en">{{$t('common.lang_en')}}</option>
                  <option value="ja">{{$t('common.lang_ja')}}</option>
                </select>
              </form>
            </div>
          </li>
          <!--
          <li class="nav-item">
            <form>
              <div class="form-group col">
                <div class="input-group no-border">
                  <input
                    type="text"
                    value
                    id="searchInput"
                    class="form-control"
                    placeholder="Search..."
                  />
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <i class="nc-icon nc-zoom-split"></i>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </li>
          <li class="nav-item">
            <a class="nav-link btn-magnify" href="#pablo">
              <i class="nc-icon nc-layout-11"></i>
              <p>
                <span class="d-lg-none d-md-block">Stats</span>
              </p>
            </a>
          </li>
          <li class="nav-item btn-rotate dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <i class="nc-icon nc-bell-55"></i>
              <p>
                <span class="d-lg-none d-md-block">Some Actions</span>
              </p>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" href="#">Action</a>
              <a class="dropdown-item" href="#">Another action</a>
              <a class="dropdown-item" href="#">Something else here</a>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link btn-rotate" href="#pablo">
              <i class="nc-icon nc-settings-gear-65"></i>
              <p>
                <span class="d-lg-none d-md-block">Account</span>
              </p>
            </a>
          </li>
          -->
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { LOCAL_STORAGE_KEY } from '../const/localstorageKey';
import axios from 'axios';

export default {
  data() {
        return {
            item: {
                label: 'aintone_kintone_plugin.zip',
                // copy the file to your public folder
                url: '/kintone_plugin/aintone_kintone_plugin.zip',}
        }
  },
  methods: {
    setLang() {
      localStorage.setItem(LOCAL_STORAGE_KEY.LANGUAGE, this.$i18n.locale);
      document.title = this.$t(`${this.$route.meta.title}.title_page`);
    },
    downloadPluginZipFile ({ url, label }) {
      axios.get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    }
  }
};
</script>
